import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import { useAuth } from '../context/AuthContext';
import { shouldShowBackButton } from '../constants/menuItems';

const getPageTitle = (pathname) => {
    if (pathname.startsWith('/dashboard')) return 'Events';
    if (pathname === '/candidates') return 'User Management';
    if (pathname.startsWith('/candidates/')) return 'Candidates';
    if (pathname.startsWith('/categories/')) return 'Category Details';
    if (pathname.startsWith('/categories')) return 'Categories';
    if (pathname.startsWith('/report')) return 'Report Details';
    if (pathname.startsWith('/consolidated')) return 'Consolidated Report';

    // Dynamically extract the name param for event details
    // Route: /event/:id/:name
    if (pathname.startsWith('/event/')) {
        const parts = pathname.split('/');
        if (parts.length >= 4) {
            return decodeURIComponent(parts[3]);
        }
    }

    // Dynamic extraction for lessons
    if (pathname.startsWith('/lessons/') || pathname.startsWith('/lesson/')) {
        return 'Lesson Viewer';
    }

    if (pathname.startsWith('/quiz')) return 'Quiz';

    return 'vTest'; // Default fallback
};

const GlobalLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { role } = useAuth();
    
    const [customTitle, setCustomTitle] = React.useState(null);
    
    // Clear custom title on route change to prevent stale titles
    React.useEffect(() => {
        setCustomTitle(null);
    }, [location.pathname]);

    const dynamicTitle = customTitle || getPageTitle(location.pathname);
    const showBackButton = shouldShowBackButton(role, location.pathname);

    return (
        <div className="flex flex-col min-h-screen bg-campus-bg">
            <Header headerTitle={dynamicTitle} />
            {showBackButton && (
                <div className="sticky top-16 z-40 bg-campus-surface border-b border-campus-border">
                    <div className="px-4 py-3 sm:px-6 flex items-center justify-between relative min-h-[64px]">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="inline-flex items-center gap-3 rounded-full border border-campus-border bg-campus-surface px-4 py-2 text-sm font-medium text-campus-text-primary transition-colors duration-200 hover:border-campus-primary hover:text-campus-primary focus:outline-none focus:ring-2 focus:ring-campus-primary focus:ring-offset-2 z-10"
                            aria-label="Go back"
                        >
                            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-50 text-campus-primary">
                                <FaChevronLeft size={12} />
                            </span>
                            <span>Back</span>
                        </button>
                        <div id="global-header-actions" className="flex-1 flex items-center"></div>
                    </div>
                </div>
            )}
            <main className="flex-grow">
                <Outlet context={{ setCustomTitle }} />
            </main>
            <Footer />
        </div>
    );
};

export default GlobalLayout;
